import BaseURL from "./baseURL";

const resultAPI = {
	POINTS_URL: `${BaseURL.LOCAL_BASE_URL}/result/points`,
};

export default resultAPI;
